import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      marginRight: 12,
      all: 'unset',
      alignItems: 'center',
      border: '1px solid var(--x-accent-2-1)',
      cursor: 'pointer',
      display: 'flex',
      borderRadius: 50,
      padding: [5, 16],
      color: 'var(--x-accent-2-1)',
      fontSize: 14,
      fontWeight: 600,
      lineHeight: '20px',

      '&:hover': {
        borderColor: 'var(--x-accent-2-6)',
        color: 'var(--x-accent-2-6)',

        '& $icon': {
          '& path': { fill: 'var(--x-accent-2-6)' },
        },

        '&[disabled]': {
          cursor: 'initial',
          color: '#bd9af8',
          borderColor: '#bd9af8',

          '& $icon': {
            '& path': {
              fill: '#bd9af8',
            },
          },
        },
      },

      '&[disabled]': {
        cursor: 'initial',
        color: '#bd9af8',
        borderColor: '#bd9af8',

        '& $icon': {
          '& path': {
            fill: '#bd9af8',
          },
        },
      },
    },

    tooltip: {
      '& .with-tooltip-inner': {
        width: 271,
      },
    },

    icon: {
      marginLeft: 4,
      '& path': { fill: 'var(--x-accent-2-1)' },
    },
  },
  {
    name: 'LinkButton',
  },
);

export default useStyles;
